import { supabase } from './supabase'

/**
 * Calls the stripe-proxy Supabase Edge Function.
 * The Stripe secret key never leaves the server.
 */
async function callStripeProxy(action, payload = {}) {
  const { data, error } = await supabase.functions.invoke('stripe-proxy', {
    body: { action, payload },
  })

  if (error) throw new Error(error.message || 'Stripe proxy error')
  if (data?.error) throw new Error(data.error)
  return data
}

/** Create a Stripe product + price + payment link in one shot */
export async function createStripeProduct({ name, description, price, images, metadata }) {
  return callStripeProxy('create_product', { name, description, price, images, metadata })
}

/** Update an existing Stripe product (name, description, images, active) */
export async function updateStripeProduct({ product_id, name, description, images, active }) {
  return callStripeProxy('update_product', { product_id, name, description, images, active })
}

/** Deactivate a Stripe payment link */
export async function deactivateStripePaymentLink(payment_link_id) {
  return callStripeProxy('deactivate_payment_link', { payment_link_id })
}

/** Activate (re-enable) a Stripe payment link */
export async function activateStripePaymentLink(payment_link_id) {
  return callStripeProxy('activate_payment_link', { payment_link_id })
}

/** Create a new payment link for an existing price */
export async function createStripePaymentLink(price_id) {
  return callStripeProxy('create_payment_link', { price_id })
}

/** List all active Stripe products */
export async function listStripeProducts() {
  return callStripeProxy('list_products')
}
